import { useState } from 'react';
import { ConnectButton } from '../../components/ConnectButton';
export function Test() {
    const [connected, setConnected] = useState(false);
    return <div className='absolute left-[200px] top-[200px]'><ConnectButton connected={connected} onClick={() => {
        setConnected(!connected);
    }} />
    </div>;
}
